/**
 * Check if an order has a "Livraison Express" product in its order_lines.
 */
export function hasExpress(order) {
  return (order?.order_lines || []).some(l =>
    (l.product_name || '').toLowerCase().includes('express')
  );
}
